import React, { CSSProperties, ReactNode, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import useOnclickOutside from "hooks/useOnclickOutside/useOnclickOutside";
import { websiteBuilderSelectPage } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useTranslation } from "react-i18next";
import { faCheck, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import { TWebsiteBuilderWebsiteVersionNavigationMenuItem } from "redux/reducers/models/websiteBuilder";
import "./websiteBuilderBannerPageDropdown.scss";

export function WebsiteBuilderBannerPageDropdown() {
  const { t } = useTranslation();
  
  const dispatch = useAppDispatch();

  const navigationMenuItems = useAppSelector(store => store.websiteBuilderStore.editor.navigationMenuItems);
  const pageMap = useAppSelector(store => store.websiteBuilderStore.editor.pageMap);
  const activePageId = useAppSelector(store => store.websiteBuilderStore.editor.activePageId);

  const [open, setOpen] = useState<boolean>(false);

  const dropdownRef = useOnclickOutside(() => {
    setOpen(false);
  });

  function handleDropbuttonClick(e: React.MouseEvent) {
    e.stopPropagation();

    setOpen(prev => !prev);
  }

  function handleSelectPage(e: React.MouseEvent, id: number) {
    e.stopPropagation();

    dispatch(websiteBuilderSelectPage({ activePageId: id }));
    setOpen(false);
  }

  function renderBannerDropdownOptions(items: TWebsiteBuilderWebsiteVersionNavigationMenuItem[], depth: number): ReactNode[] {
    return items.map(item => {
      const paddingStyle: CSSProperties = { paddingLeft: `${depth * 24}px`, paddingRight: `${depth * 24}px` };

      if (item.type === "page") {
        const page = pageMap.get(item.page_id);

        if (page == null) {
          return null;
        }

        const pageSelected = page.id === activePageId;

        return (
          <div
            key={item.id}
            className={classNames("banner-page-dropdown-option-page", {
              "banner-page-dropdown-option-page-selected": pageSelected,
            })}
            style={paddingStyle}
            onClick={e => handleSelectPage(e, page.id)}
          >
            <div className="banner-page-dropdown-option-page-title">{page.title}</div>
            {pageSelected ? <FontAwesomeIcon icon={faCheck} /> : null}
          </div>
        );
      } else if (item.type === "dropdown") {
        return (
          <React.Fragment key={item.id}>
            <div
              className="banner-page-dropdown-option-dropdown"
              style={paddingStyle}
            >
              <div className="banner-page-dropdown-option-dropdown-title">{item.label}</div>
            </div>
            {renderBannerDropdownOptions(item.children, 2)}
          </React.Fragment>
        );
      } else {
        return null;
      }
    });
  }

  return (
    <div
      ref={dropdownRef}
      className="website-builder-banner-page-dropdown"
    >
      <div
        className="banner-page-dropdown-dropbutton"
        onClick={handleDropbuttonClick}
      >
        {t("Pages")}
        <FontAwesomeIcon className="banner-page-dropdown-dropbutton-icon" icon={open ? faChevronUp : faChevronDown} />
      </div>
      <div
        className="banner-page-dropdown-content"
        style={{
          display: open ? "block" : "none",
        }}
      >
        <div className="banner-page-dropdown-header">{t("Select page")}</div>
        {renderBannerDropdownOptions(navigationMenuItems, 1)}
      </div>
    </div>
  );
}
